import { Brand } from './brand';
import { MaintenanceTask } from './maintenance-task';

export class ModelMaintenance {
  constructor(
    public hash: string,
    public name: string,
    public reference: number,
    public order: number,
    public active: boolean,
    public ip: string,
    public readMode: string,
    public serie: string,
    public imagePath: string,
    public brand: Brand,
    public lastMaintenance: MaintenanceTask,
    public nextMaintenance: MaintenanceTask
  ) { }

  clone() {
    return new ModelMaintenance(
      this.hash,
      this.name,
      this.reference,
      this.order,
      this.active,
      this.ip,
      this.readMode,
      this.serie,
      this.imagePath,
      this.brand,
      this.lastMaintenance,
      this.nextMaintenance
    );
  }

  get modelFullName() {
    return this.name + ' - ' + this.reference;
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/model-mantenance.ts